import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Textbox } from "components/Textbox/Textbox";
import { useEffect, useState } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

import { ICON_TYPE } from "utils/constants";
import { trans } from "utils/helpers";
import { getItemPropertyValuesFilter } from "./api";

interface ItemCardsProps {
  setfilterObj: (data: any) => void;
  filterData?: any;
  ItemPropertyId?: any;
  label?: any;
  handleFilter?: any;
  handleRemoveFilter?: any;
  filterObj?: any;
}

export const PropertiesFilterBox = ({
  setfilterObj,
  filterData,
  ItemPropertyId,
  label,
  handleFilter,
  handleRemoveFilter,
  filterObj,
}: ItemCardsProps) => {
  const [showStep, setShowStep] = useState<any>({ 3: true });
  const [propertyValue, setPropertyValue] = useState<any>(null);
  async function getItemPropertyValuesFilterAsync() {
    try {
      const response = await getItemPropertyValuesFilter(ItemPropertyId);
      console.log("PropertyValuesFilter", response.Data);
      if (response.Data) {
        setPropertyValue(response.Data);
      } else {
        setPropertyValue({});
      }
    } catch (error) {
      setPropertyValue({});
    }
  }

  useEffect(() => {
    console.log("ItemPropertyId", ItemPropertyId);
    if (ItemPropertyId) {
      getItemPropertyValuesFilterAsync();
    }
  }, [ItemPropertyId]);
  return (
    <div>
      <div className={`card mb-3 `}>
        <div
          style={{
            backgroundColor: "#f97316",
            color: "#fff",
            paddingRight: "20px",
            justifyContent: "space-between",
          }}
          className="d-flex  py-1 col-12 pr-4"
        >
  <OverlayTrigger
            key={label}
            placement="top"
            delay={{ show: 600, hide: 0 }}
            overlay={
              <Tooltip className="tooltip " id={`button-tooltip-${"reserve"}`}>
                {label}
              </Tooltip>
            }
          >
       <div style={{ whiteSpace: "nowrap" }} className="showDots">{label}</div>
          </OverlayTrigger> 
          <div
            style={{ marginLeft: "18px" }}
            onClick={() => {
              showStep[1]
                ? setShowStep({ ...showStep, 1: false })
                : setShowStep({ ...showStep, 1: true });
            }}
          >
            {showStep[1] ? (
              <FontAwesomeIcon
                icon={[ICON_TYPE, "angle-down"]}
                size="lg"
                className="icon"
              />
            ) : (
              <FontAwesomeIcon
                icon={[ICON_TYPE, "angle-up"]}
                size="lg"
                className="icon"
              />
            )}
          </div>
        </div>
        <div
          style={{ display: !showStep[1] ? "block" : "none" }}
          className="card-body"
        >
          {propertyValue &&
          Object.keys(propertyValue) &&
          Object.keys(propertyValue).length > 0 &&
          ItemPropertyId ? (
            <>
              {Object.keys(propertyValue)?.map((item, index) => (
                <>
                  <input
                    key={index}
                    type="checkbox"
                    onClick={(e) => {
                      // setfilterArray({ option: item });
                    }}
                    id={item + index}
                    name={item}
                    value={propertyValue[item]}
                  />
                  <label className="mx-1" htmlFor={item + index}>
                    {propertyValue[item]}
                  </label>
                  <br></br>
                </>
              ))}
            </>
          ) : (
            <>
              <Textbox
                key={ItemPropertyId}
                withLabel={false}
                textboxType="text"
                onChange={(e) => {
                  // setfilterArray({ option: item });
                }}
                withMsg={false}
                textboxName={ItemPropertyId}
              />

              <br></br>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
